<template>
  <div class="" testek="product-detail">
    <div class="header"></div>
    <BaseDetail
      @viewDetail="viewDetail"
      @addData="addData"
      @addMoreData="addMoreData"
      :currentItem="currentItem"
      :titleDetail="$t('i18nCommon.TitleGroupId')"
      :idField="'groupId'"
    >
      <template #header>
        <div class="font-bold text-xl mb-4">{{ title }}</div>
      </template>
      <template #content>
        <div class="content">
          <div class="product-detail-form">
            <a-form
              ref="ruleFormRef"
              :model="ruleForm"
              :rules="rules"
              label-width="120px"
              class="demo-ruleForm"
              label-position="left"
              :size="formSize"
              status-icon
            >
              <a-form-item
                prop="Id"
                testek="Id"
                class="columns-1 w-full"
                v-if="mode == $enum.Mode.Edit"
              >
                <div class="flex w-full">
                  <div class="flex min-w-32 font-bold">
                    ID
                    <span class="ml-1 text-red-700">*</span>
                  </div>
                  <a-input v-model:value="ruleForm.groupId" />
                </div>
              </a-form-item>
              <div class="flex columns-2">
                <a-form-item prop="groupCode" testek="groupCode" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Code") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.groupCode" />
                  </div>
                </a-form-item>
                <a-form-item prop="groupName" testek="groupName" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Name") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.groupName" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item prop="description" testek="description" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Description") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-textarea v-model:value="ruleForm.description" class="w-full" />
                  </div>
                </a-form-item>
              </div>
              <a-form-item class="mt-6">
                <div class="flex">
                  <a-button
                    type="primary"
                    testek="btn-add"
                    @click="submitForm()"
                    class="mr-4"
                  >
                    {{ $t("i18nCommon.Add") }}
                  </a-button>
                  <a-button type="primary" testek="btn-add-more" @click="addMoreData()">
                    {{ $t("i18nCommon.AddMore") }}
                  </a-button>
                </div>
              </a-form-item>
            </a-form>
          </div>
        </div>
      </template>
    </BaseDetail>
    <div v-if="isShow && group">
      <a-modal v-model:open="isShow" :closable="false" centered :width="800">
        <div class="header-detail flex justify-between mb-6">
          <div class="font-bold text-2xl">
            {{ $t("i18nCommon.TitleDetailInfo") }}
          </div>
          <div
            class="text-white h-9 w-36 bg-slate-900 rounded-lg flex justify-center items-center"
          >
            {{ $t("i18nCommon.Group") }}
          </div>
        </div>
        <div class="content">
          <div class="product-detail-form">
            <a-form
              ref="ruleFormRef"
              :rules="rules"
              label-width="120px"
              class="demo-ruleForm"
              label-position="left"
              :size="formSize"
              status-icon
            >
              <a-form-item
                prop="Id"
                testek="Id"
                class="columns-1 w-full"
                v-if="mode == $enum.Mode.Edit"
              >
                <div class="flex w-full">
                  <div class="flex min-w-32 font-bold">ID</div>
                  <a-input v-model:value="group.groupId" :disabled="true" />
                </div>
              </a-form-item>
              <div class="flex columns-2">
                <a-form-item prop="groupCode" testek="groupCode" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Code") }}
                    </div>
                    <a-input v-model:value="group.groupCode" :disabled="true" />
                  </div>
                </a-form-item>
                <a-form-item prop="groupName" testek="groupName" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Name") }}
                    </div>
                    <a-input v-model:value="group.groupName" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item prop="description" testek="description" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Description") }}
                    </div>
                    <a-textarea
                      v-model:value="group.description"
                      :disabled="true"
                      class="w-full"
                    />
                  </div>
                </a-form-item>
              </div>
            </a-form>
          </div>
        </div>
        <template #footer>
          <a-button key="back" @click="isShow = false">{{
            $t("i18nCommon.Close")
          }}</a-button>
        </template>
      </a-modal>
    </div>
  </div>
</template>

<script>
import { ModuleAuth, ModuleGroup } from "@/store/module-const";
import BaseDetail from "@/views/base/BaseDetail.vue";
import { mapActions } from "vuex";
import _ from "lodash";
export default {
  name: "GroupDetail",
  components: {
    BaseDetail,
  },
  props: {},
  computed: {
    title() {
      if (this.mode == this.$enum.Mode.Edit) return this.$t("i18nCommon.EditGroup");
      return this.$t("i18nCommon.AddGroup");
    },
  },
  data() {
    return {
      ruleForm: {},
      rules: {},
      currentItem: {},
      group: {},
      isShow: false,
      mode: this.$enum.Mode.Add,
    };
  },
  created() {
    const me = this;
    me.initDataStatic();
    me.$emitter.on("LoadEditGroup", me.loadDataEdit);
  },
  beforeDestroy() {
    const me = this;
    me.$emitter.off("LoadEditGroup", me.loadDataEdit);
  },
  methods: {
    ...mapActions(ModuleGroup, [
      "createGroup",
      "getGroup",
      "updateGroup",
      "updatePolicyGroup",
    ]),
    ...mapActions(ModuleAuth, ["createPolicy"]),
    initDataStatic() {
      const me = this;
      me.rules = {
        description: [
          {
            required: true,
            message: `${me.$t("i18nProduct.DescriptionInvalid")}`,
            trigger: "blur",
          },
        ],
        groupCode: [
          {
            required: true,
            message: `${me.$t("i18nProduct.CodeInvalid")}`,
            trigger: "blur",
          },
        ],
        groupName: [
          {
            required: true,
            message: `${me.$t("i18nProduct.NameInvalid")}`,
            trigger: ["change", "blur"],
          },
        ],
      };
      me.statuses = this.$config.StatusInfos;
    },
    loadDataEdit: _.debounce(async function (payload) {
      const me = this;
      if (!payload) return;
      me.mode = payload.mode;
      setTimeout(async () => {
        let group = await me.getGroup({ id: payload.id });
        if (group) {
          me.ruleForm = {
            groupId: group.groupId,
            groupName: group.groupName,
            description: group.description,
            groupCode: group.groupCode,
            status: group.status,
          };
        }
      }, 500);
    }, 300),
    async submitForm(isReset = true) {
      const me = this;
      let formEl = me.$refs.ruleFormRef;
      if (!formEl) return;
      formEl
        .validate()
        .then(async () => {
          if (me.mode == me.$enum.Mode.Edit) {
            await me.editData();
          } else {
            await me.addData(isReset);
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },

    addMoreData: _.debounce(async function () {
      const me = this;
      await me.submitForm(false);
    }, 300),

    addData: _.debounce(async function (isReset = true) {
      const me = this;
      let result = await me.createGroup(me.ruleForm);
      if (result && result.data) {
        me.currentItem = result.data;
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.AddGroupSuccess")
        );

        //Tạo policy
        let policy = {
          description: `POLICY_${me.ruleForm.description}`,
          policyCode: `POLICY_${me.ruleForm.groupCode}`,
          policyName: `POLICY_${me.ruleForm.groupName}`,
          resourceScopes: [],
          status: "ACTIVE",
        };
        let policyInfoResult = await me.createPolicy(policy);
        if (policyInfoResult && policyInfoResult.data) {
          let policyInfo = policyInfoResult.data;
          //Cập nhật Policy này vào group
          await me.updatePolicyGroup({
            policyId: policyInfo.policyId,
            groupId: me.currentItem.groupId,
          });
        } else if (
          policyInfoResult &&
          (policyInfoResult.statusCode == 400 || policyInfoResult.statusCode == 409)
        ) {
          this.$messageNotification.messageNotification(
            policyInfoResult.message,
            "warning"
          );
        }
        if (isReset == true) {
          me.ruleForm = {};
        }
      } else if (result && (result.statusCode == 400 || result.statusCode == 409)) {
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(result.message, "warning");
      } else {
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.AddGroupFail"),
          "warning"
        );
      }
    }, 300),

    editData: _.debounce(async function () {
      const me = this;
      let result = await me.updateGroup(me.ruleForm);
      if (result && result.data && result.data.length > 0) {
        me.currentItem = result.data[0];
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.EditGroupSuccess")
        );
        me.ruleForm = {};
      } else if (result && (result.statusCode == 400 || result.statusCode == 409)) {
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(result.message, "warning");
      } else {
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.EditGroupFail"),
          "warning"
        );
      }
    }, 300),

    viewDetail: _.debounce(async function (params) {
      const me = this;
      if (!params || !params.groupId) return;

      //lấy dữ liệu chi tiết từ API
      me.group = await me.getGroup({ id: params.groupId });
      if (me.group) {
        me.isShow = true;
      } else {
      }
      //Show form chi tiết
    }, 300),
  },
};
</script>

<style lang="scss" scoped>
.ant-input[disabled] {
  background: initial !important;
  color: initial !important;
}
</style>
